import { LOCALE_COUNTRY_MAP } from './resolveGeoScenario'

/**
 * Build the redirect destination for the same-site locale mismatch CTA.
 *
 * asPath may or may not include the current locale prefix (Next.js i18n
 * routing strips it from asPath in some navigation states) — normalize by
 * removing it when present, then prepend the suggested locale.
 *
 * Query params are preserved (e.g. mock_country) so QAs keep the simulated
 * location after the redirect.
 *
 * Examples (suggestedLocale = 'co'):
 * - '/ar/home'            -> '/co/home'
 * - '/home'               -> '/co/home'
 * - '/ar'                 -> '/co'
 * - '/ar/home?mock_country=co' -> '/co/home?mock_country=co'
 * - '/ar/home#plans'      -> '/co/home#plans'
 */
export function buildSameSiteDestination(
  asPath: string | undefined,
  suggestedLocale: string
): string {
  const [pathWithHash, query] = (asPath ?? '/').split('?')
  const [pathWithoutHash, hash] = pathWithHash.split('#')
  let segments = pathWithoutHash.split('/').filter(Boolean)
  const localePattern = new RegExp(
    `^(${Object.keys(LOCALE_COUNTRY_MAP).join('|')})$`
  )

  if (segments.length && localePattern.test(segments[0])) {
    segments = segments.slice(1)
  }
  const pathSuffix = segments.length ? `/${segments.join('/')}` : ''
  const destination = `/${suggestedLocale}${pathSuffix}`
  const suffix = [hash ? `#${hash}` : '', query ? `?${query}` : ''].join('')

  return `${destination}${suffix}`
}
